import React from 'react';
import Grid from '@material-ui/core/Grid';
import styles from './M3BusinessesSection.module.css';

import menuFitness from '../../../../static/assets/img/icon/m3/menu-Fitness.png';
import menuMartialArts from '../../../../static/assets/img/icon/m3/menu-Martial Arts.png';
import menuPersonalTrainer from '../../../../static/assets/img/icon/m3/menu-Personal Trainer.png';
import menuYoga from '../../../../static/assets/img/icon/m3/menu-Yoga.png';
import menuDance from '../../../../static/assets/img/icon/m3/menu-Dance.png';
import menuMusic from '../../../../static/assets/img/icon/m3/menu-Music.png';
import menuArt from '../../../../static/assets/img/icon/m3/menu-Art.png';
import menuLanguage from '../../../../static/assets/img/icon/m3/menu-Language.png';
import menuAfterSchool from '../../../../static/assets/img/icon/m3/menu-After School.png';

const BUSINESS_TYPES = [
  { name: 'Fitness / Gym', icon: menuFitness },
  { name: 'Martial Arts', icon: menuMartialArts },
  { name: 'Personal Trainer', icon: menuPersonalTrainer },
  { name: 'Yoga / Pilates', icon: menuYoga },
  { name: 'Dance School', icon: menuDance },
  { name: 'Music School', icon: menuMusic },
  { name: 'Art School', icon: menuArt },
  { name: 'Math / Language School', icon: menuLanguage },
  { name: 'After School Program', icon: menuAfterSchool },
];

class M3BusinessesSection extends React.Component {
  componentDidMount() {
    window.dispatchEvent(new Event('hideHeaderBg'));
  }

  render() {
    return (
      <section
        className={`${styles.pageSection} section`}
        data-anchor="MainSection"
      >
        <div className={styles.backdrop} aria-hidden="true" />
        <Grid
          container
          spacing={0}
          direction="column"
          wrap="nowrap"
          className={`${styles.contentContainer} contentContainer`}
        >
          <Grid item xs={12} className={styles.headerBlock}>
            <div className={`sectionTitle ${styles.eyebrow}`}>M3</div>
            <div className="sectionTitleUnderline ul-center" />
            <h1 className={`articleBigTitle ${styles.headline}`}>
              Built for membership-based businesses
            </h1>
            <p className={styles.intro}>
              Classes, renewals, check-ins, and billing—M3 fits studios, schools, and gyms
              that live on memberships. Below are just a few of the industries teams use it in today.
            </p>
          </Grid>
          <Grid item xs={12} className={styles.gridWrap}>
            <Grid
              container
              spacing={2}
              justify="center"
              className={styles.cardGrid}
            >
              {BUSINESS_TYPES.map((item) => (
                <Grid item xs={6} sm={4} md={4} key={item.name} className={styles.cardCol}>
                  <div className={styles.card}>
                    <div className={styles.iconWrap}>
                      <img src={item.icon} alt="" className={styles.icon} />
                    </div>
                    <div className={styles.cardName}>{item.name}</div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} className={styles.scrollHintRow}>
            <p className={styles.scrollHint}>Scroll to explore features</p>
          </Grid>
        </Grid>
      </section>
    );
  }
}

export default M3BusinessesSection;
